export default __webpack_public_path__ + "static/media/email.b6bb00ce.png";